import {useMemo} from "react";
import {css} from "@emotion/react";
import {getMonth, parseISO} from "date-fns";

import {flexAbsoluteCenter, onDesktop, p} from "@pg-design/helpers-css";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {calculatePercent} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";
import {PricesChartDescriptionText} from "./PricesChartDescriptionText";

interface IProps {
    type: PricesViewType;
    rooms: RoomsType;
    actualData: IPriceReportAveragePrices | null;
    monthBeforeData: IPriceReportAveragePrices | null;
    yearAgoData: IPriceReportAveragePrices;
    region: IRegionReportPrice;
}

export const PricesChartDescription = (props: IProps) => {
    const {rooms, type, actualData, yearAgoData, monthBeforeData, region} = props;
    //getMonth return 0 -January, 1 - February, ..., +1 needed for monthWhenVerbose function
    const month = actualData ? getMonth(parseISO(actualData.date)) + 1 : 0;

    const percentValues = useMemo(() => {
        if (monthBeforeData && yearAgoData && actualData) {
            return {
                [RoomsType.GENERAL]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2, actualData.avg_price_m2),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2, actualData.avg_price_m2)
                },
                [RoomsType.ONE_ROOM]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_studio, actualData.avg_price_m2_studio),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_studio, actualData.avg_price_m2_studio)
                },
                [RoomsType.TWO_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_2_rooms, actualData.avg_price_m2_2_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_2_rooms, actualData.avg_price_m2_2_rooms)
                },
                [RoomsType.THREE_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_3_rooms, actualData.avg_price_m2_3_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_3_rooms, actualData.avg_price_m2_3_rooms)
                },
                [RoomsType.FOUR_OR_MORE_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_4_plus_rooms, actualData.avg_price_m2_4_plus_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_4_plus_rooms, actualData.avg_price_m2_4_plus_rooms)
                }
            };
        }
        return {};
    }, [monthBeforeData, yearAgoData, actualData]);

    return (
        <div css={descriptionHolder}>
            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.GENERAL}
                percentYearToYear={percentValues[RoomsType.GENERAL]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.GENERAL]?.monthly}
                priceM2={actualData?.avg_price_m2}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.GENERAL}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.ONE_ROOM}
                percentYearToYear={percentValues[RoomsType.ONE_ROOM]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.ONE_ROOM]?.monthly}
                priceM2={actualData?.avg_price_m2_studio}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.ONE_ROOM}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.TWO_ROOMS}
                percentYearToYear={percentValues[RoomsType.TWO_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.TWO_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_2_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.TWO_ROOMS}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.THREE_ROOMS}
                percentYearToYear={percentValues[RoomsType.THREE_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.THREE_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_3_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.THREE_ROOMS}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.FOUR_OR_MORE_ROOMS}
                percentYearToYear={percentValues[RoomsType.FOUR_OR_MORE_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.FOUR_OR_MORE_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_4_plus_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.FOUR_OR_MORE_ROOMS}
            />
        </div>
    );
};

const descriptionHolder = css`
    ${flexAbsoluteCenter};
    ${p(0, 1.5, 1.5, 1.5)};

    ${onDesktop(css`
        ${p(0, 8, 0, 8)};
    `)};
`;
import {useMemo} from "react";
import {css} from "@emotion/react";
import {getMonth, parseISO} from "date-fns";

import {flexAbsoluteCenter, onDesktop, p} from "@pg-design/helpers-css";

import {IRegionReportPrice} from "../../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../../types/IPriceReportAveragePrices";
import {calculatePercent} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";
import {PricesChartDescriptionText} from "./PricesChartDescriptionText";

interface IProps {
    type: PricesViewType;
    rooms: RoomsType;
    actualData: IPriceReportAveragePrices | null;
    monthBeforeData: IPriceReportAveragePrices | null;
    yearAgoData: IPriceReportAveragePrices;
    region: IRegionReportPrice;
}

export const PricesChartDescription = (props: IProps) => {
    const {rooms, type, actualData, yearAgoData, monthBeforeData, region} = props;
    //getMonth return 0 -January, 1 - February, ..., +1 needed for monthWhenVerbose function
    const month = actualData ? getMonth(parseISO(actualData.date)) + 1 : 0;

    const percentValues = useMemo(() => {
        if (monthBeforeData && yearAgoData && actualData) {
            return {
                [RoomsType.GENERAL]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2, actualData.avg_price_m2),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2, actualData.avg_price_m2)
                },
                [RoomsType.ONE_ROOM]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_studio, actualData.avg_price_m2_studio),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_studio, actualData.avg_price_m2_studio)
                },
                [RoomsType.TWO_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_2_rooms, actualData.avg_price_m2_2_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_2_rooms, actualData.avg_price_m2_2_rooms)
                },
                [RoomsType.THREE_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_3_rooms, actualData.avg_price_m2_3_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_3_rooms, actualData.avg_price_m2_3_rooms)
                },
                [RoomsType.FOUR_OR_MORE_ROOMS]: {
                    monthly: calculatePercent(monthBeforeData.avg_price_m2_4_plus_rooms, actualData.avg_price_m2_4_plus_rooms),
                    yerToYear: calculatePercent(yearAgoData.avg_price_m2_4_plus_rooms, actualData.avg_price_m2_4_plus_rooms)
                }
            };
        }
        return {};
    }, [monthBeforeData, yearAgoData, actualData]);

    return (
        <div css={descriptionHolder}>
            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.GENERAL}
                percentYearToYear={percentValues[RoomsType.GENERAL]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.GENERAL]?.monthly}
                priceM2={actualData?.avg_price_m2}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.GENERAL}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.ONE_ROOM}
                percentYearToYear={percentValues[RoomsType.ONE_ROOM]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.ONE_ROOM]?.monthly}
                priceM2={actualData?.avg_price_m2_studio}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.ONE_ROOM}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.TWO_ROOMS}
                percentYearToYear={percentValues[RoomsType.TWO_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.TWO_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_2_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.TWO_ROOMS}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.THREE_ROOMS}
                percentYearToYear={percentValues[RoomsType.THREE_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.THREE_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_3_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.THREE_ROOMS}
            />

            <PricesChartDescriptionText
                type={type}
                roomsType={RoomsType.FOUR_OR_MORE_ROOMS}
                percentYearToYear={percentValues[RoomsType.FOUR_OR_MORE_ROOMS]?.yerToYear}
                percentMonthToMonth={percentValues[RoomsType.FOUR_OR_MORE_ROOMS]?.monthly}
                priceM2={actualData?.avg_price_m2_4_plus_rooms}
                month={month}
                regionNameWhere={region.name_declension_where}
                isVisible={rooms === RoomsType.FOUR_OR_MORE_ROOMS}
            />
        </div>
    );
};

const descriptionHolder = css`
    ${flexAbsoluteCenter};
    ${p(0, 1.5, 1.5, 1.5)};

    ${onDesktop(css`
        ${p(0, 8, 0, 8)};
    `)};
`;
